const sanDiegoRun = {
  resource_state: 2,
  athlete: {
    id: 0, // omit
    resource_state: 1,
  },
  name: "Last Morning in San Diego",
  distance: 7977,
  moving_time: 2201,
  elapsed_time: 2645,
  total_elevation_gain: 10.3,
  type: "Run",
  sport_type: "Run",
  workout_type: null,
  id: 0, // omit
  start_date: "2017-11-04T15:42:39Z",
  start_date_local: "2017-11-04T08:42:39Z",
  timezone: "(GMT-08:00) America/Los_Angeles",
  utc_offset: -25200,
  location_city: null,
  location_state: null,
  location_country: "United States",
  achievement_count: 5,
  kudos_count: 3,
  comment_count: 0,
  athlete_count: 1,
  photo_count: 1,
  map: {
    id: "a1261461890",
    summary_polyline:
      "_}sfEptajUm@zo@rCfGyAhFa@|QcG|CmcAKsH~AoE|CiDlGaApMv@~JmA`JhAaJy@ePnAeIbE_HnF}CxjAe@ZpB_B`Cv@bDnEa@qBmJjGcEs@cSy@Bt@sEkAmDfA}J]wd@",
    resource_state: 2,
  },
  trainer: false,
  commute: false,
  manual: false,
  private: false,
  visibility: "everyone",
  flagged: false,
  gear_id: "g2701150",
  start_latlng: [32.711368, -117.159282],
  end_latlng: [32.711501, -117.159403],
  average_speed: 3.624,
  max_speed: 6.2,
  has_heartrate: false,
  heartrate_opt_out: false,
  display_hide_heartrate_option: false,
  elev_high: 10.1,
  elev_low: 1.5,
  upload_id: 0, // omit
  upload_id_str: "0", // omit
  external_id: "0", // omit
  from_accepted_tag: false,
  pr_count: 5,
  total_photo_count: 1,
  has_kudoed: false,
  device_name: "Garmin Forerunner 255S Music",
};

const uclaSantaMonicaRun = {
  resource_state: 2,
  athlete: {
    id: 0, // omit
    resource_state: 1,
  },
  name: "Return Home",
  distance: 10733.2,
  moving_time: 2849,
  elapsed_time: 3569,
  total_elevation_gain: 11.4,
  type: "Run",
  sport_type: "Run",
  workout_type: null,
  id: 0, // omit
  start_date: "2017-11-14T23:12:47Z",
  start_date_local: "2017-11-14T15:12:47Z",
  timezone: "(GMT-08:00) America/Los_Angeles",
  utc_offset: -28800,
  location_city: null,
  location_state: null,
  location_country: "United States",
  achievement_count: 3,
  kudos_count: 4,
  comment_count: 0,
  athlete_count: 1,
  photo_count: 1,
  map: {
    id: "a1275772452",
    summary_polyline:
      "kb}nErg|qUhIuAbQd@xB`Ci@lNhRn@|ChDjEgCzCd@JgBfBv@jT}KfCnC`F{Dzg@n`Aj}@qt@bIpOrHyD`VvsBnLfg@la@ch@r`@yZyF}PfFmC~CyFjFaA^cBkEgDiJzGbDhH",
    resource_state: 2,
  },
  trainer: false,
  commute: true,
  manual: false,
  private: false,
  visibility: "everyone",
  flagged: false,
  gear_id: "g2554325",
  start_latlng: [34.069027, -118.442333],
  end_latlng: [34.01612, -118.457417],
  average_speed: 3.767,
  max_speed: 6.4,
  has_heartrate: false,
  heartrate_opt_out: false,
  display_hide_heartrate_option: false,
  elev_high: 130,
  elev_low: 41.7,
  upload_id: 0, // omit
  upload_id_str: "0", // omit
  external_id: "0", // omit
  from_accepted_tag: false,
  pr_count: 0,
  total_photo_count: 1,
  has_kudoed: false,
  device_name: "Samsung Galaxy Ultra",
};

const vancouverLaps = {
  resource_state: 2,
  athlete: {
    id: 0, // omit
    resource_state: 1,
  },
  name: "Afternoon Laps",
  distance: 6003.4,
  moving_time: 1770,
  elapsed_time: 1784,
  total_elevation_gain: 650,
  type: "Run",
  sport_type: "Run",
  workout_type: null,
  id: 0, // omit
  start_date: "2014-12-24T23:26:37Z",
  start_date_local: "2014-12-24T15:26:37Z",
  timezone: "(GMT-08:00) America/Vancouver",
  utc_offset: -28800,
  location_city: "Vancouver",
  location_state: "British Columbia",
  location_country: "Canada",
  achievement_count: 0,
  kudos_count: 1,
  comment_count: 0,
  athlete_count: 1,
  photo_count: 0,
  map: {
    id: "a232581807",
    summary_polyline:
      "qttkHpbvnVpHl@jB{Mg@mKwIO_@vXdAv@~FBt@eWWgBcIb@YbX`Il@t@eZ{Hm@q@fCIzUjHz@vAgNIsK_JG[pX~Ht@r@kKKsMkIPe@dWbIxAf@}FPoRqICk@jY",
    resource_state: 2,
  },
  trainer: false,
  commute: false,
  manual: false,
  private: true,
  visibility: "everyone",
  flagged: false,
  gear_id: null,
  start_latlng: [49.262974, -123.162169],
  end_latlng: [49.263019, -123.162222],
  average_speed: 3.392,
  max_speed: 4.9,
  has_heartrate: false,
  heartrate_opt_out: false,
  display_hide_heartrate_option: false,
  elev_high: 37.9,
  elev_low: 28.1,
  upload_id: 0, // omit
  upload_id_str: "0", // omit
  external_id: "0", // omit
  from_accepted_tag: false,
  pr_count: 0,
  total_photo_count: 0,
  has_kudoed: false,
  device_name: "Strava App",
};

const stravaApiDocumentationRide = {
  resource_state: 2,
  athlete: {
    id: 167560,
    resource_state: 1,
  },
  name: "Back in Oakland",
  distance: 23676.5,
  moving_time: 6430,
  elapsed_time: 6600,
  total_elevation_gain: 0,
  type: "Ride",
  sport_type: "MountainBikeRide",
  workout_type: null,
  id: 154504250376825,
  external_id: "garmin_push_12345678987654321",
  upload_id: 1234567819,
  start_date: "2018-04-30T12:35:51Z",
  start_date_local: "2018-04-30T18:35:51Z",
  timezone: "(GMT-08:00) America/Los_Angeles",
  utc_offset: -25200,
  start_latlng: null,
  end_latlng: null,
  location_city: null,
  location_state: null,
  location_country: "United States",
  achievement_count: 0,
  kudos_count: 4,
  comment_count: 0,
  athlete_count: 1,
  photo_count: 0,
  map: {
    id: "a12345689",
    summary_polyline:
      "ki{eFvqfiVsBmA`Feh@qg@iX`B}JeCcCqGjIq~@kf@cM{KeHeX`@_GdGkSeBiXtB}YuEkPwFyDeAzAe@pC~DfGc@bIOsGmCcEiD~@oBuEkFhBcBmDiEfAVuDiAuD}NnDaNiIlCyDD_CtJKv@wGhD]YyEzBo@g@uKxGmHpCGtEtI~AuLrHkAcAaIvEgH_EaDR_FpBuBg@sNxHqEtHgLoTpIiCzKNr[sB|Es\\`JyObYeMbGsMnPsAfDxAnD}DBu@bCx@{BbEEyAoD`AmChNoQzMoGhOwX|[yIzBeFKg[zAkIdU_LiHxK}HzEh@vM_BtBg@xGzDbCcF~GhArHaIfByAhLsDiJuC?_HbHd@nL_Cz@ZnEkDDy@hHwJLiCbIrNrIvN_EfAjDWlEnEiAfBxDlFkBfBtEfDaAzBvDKdFx@|@XgJmDsHhAgD`GfElEzOwBnYdBxXgGlSc@bGdHpW|HdJztBnhAgFxc@HnCvBdA",
    resource_state: 2,
  },
  trainer: true,
  commute: false,
  manual: false,
  private: false,
  flagged: false,
  gear_id: "b12345678912343",
  from_accepted_tag: false,
  average_speed: 4.385,
  max_speed: 8.8,
  average_cadence: 69.8,
  average_watts: 200,
  weighted_average_watts: 214,
  kilojoules: 1080,
  device_watts: true,
  has_heartrate: true,
  average_heartrate: 152.4,
  max_heartrate: 183,
  max_watts: 403,
  pr_count: 0,
  total_photo_count: 0,
  has_kudoed: false,
  suffer_score: 162,
  device_name: "Garmin fēnix 7 Pro (47mm)",
};

/**
 * A mix of my own activities and data taken from the strava developers API
 * documentation examples, with minor modifications. Note that the data may
 * be internally inconsistent.
 */
const sampleUnparsedActivityResponses = [
  [uclaSantaMonicaRun],
  [sanDiegoRun, stravaApiDocumentationRide],
  [],
  [],
  [vancouverLaps],
];

export default sampleUnparsedActivityResponses;
